import { heroSlider, heroReviewsScroll } from "./hero";
import { initBestsellersTabs } from "./bestsellers-tabs";
import { initNewArrivals } from "./new-arrivals";
import { initManualReviews } from "./manual-reviews";
import { initHomepageBlogs } from "./blogs";

document.addEventListener('DOMContentLoaded', () => {
  heroSlider();
  heroReviewsScroll();
  initBestsellersTabs();
  initNewArrivals();
  initManualReviews();
  initHomepageBlogs();
});

document.addEventListener('shopify:section:load', (event) => {
  initBestsellersTabs(event.target);
  initNewArrivals(event.target);
  initManualReviews(event.target);
  initHomepageBlogs(event.target);
});